import React, { memo } from "react";
import { BaseEdge, getSmoothStepPath } from "reactflow";

function stripMove(p) {
  return p.replace(/^M[^A-Za-z]*\s?/, "");
}

export const BottomManualEdge = memo(function BottomManualEdge(props) {
  const {
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    markerEnd,
    style,
    data,
  } = props;

  const X_PAD = 22;
  const R = 12;

  const viaY =
    typeof data?.bottomCorridorY === "number" ? data.bottomCorridorY : Math.max(sourceY, targetY) + 80;

  const [p1] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX: sourceX + X_PAD,
    targetY: viaY,
    borderRadius: R,
  });

  const [p2] = getSmoothStepPath({
    sourceX: sourceX + X_PAD,
    sourceY: viaY,
    targetX: targetX - X_PAD,
    targetY: viaY,
    borderRadius: R,
  });

  const [p3] = getSmoothStepPath({
    sourceX: targetX - X_PAD,
    sourceY: viaY,
    targetX,
    targetY,
    borderRadius: R,
  });

  const d = `${p1} ${stripMove(p2)} ${stripMove(p3)}`;

  return <BaseEdge id={id} path={d} markerEnd={markerEnd} style={style} />;
});